import { Controller } from "@hotwired/stimulus"

// Handles the inline attribution form for orphaned (unattributed) images.
// Loads camera questions for the selected response via AJAX and populates
// the question select. On cancel, removes the form and restores the Attribute link.
export default class extends Controller {
  static targets = ["responseSelect", "questionWrapper", "questionSelect", "submitBtn"]

  async loadQuestions() {
    const responseId = this.responseSelectTarget.value
    if (!responseId) {
      this.questionWrapperTarget.classList.add("hidden")
      return
    }
    try {
      const resp = await fetch(`/responses/${responseId}/camera_questions`, {
        headers: { Accept: "application/json" }
      })
      if (!resp.ok) return
      const questions = await resp.json()
      const select = this.questionSelectTarget
      select.replaceChildren(new Option("Select a question...", ""))
      for (const q of questions) {
        select.appendChild(new Option(q.title, q.name))
      }
      this.questionWrapperTarget.classList.toggle("hidden", questions.length === 0)
    } catch {
      // Network failure -- leave the question wrapper hidden
    }
  }

  cancel(event) {
    event.preventDefault()
    // Remove the form element from the DOM. The turbo frame wrapper remains,
    // so a subsequent click on an Attribute link can re-open it.
    this.element.remove()
  }
}
